export default __webpack_public_path__ + "static/media/google.a45b46e964c34094185e40d691917f1b.svg";